<div class="title">
  <span *ngIf="cr.cr_type_activite_realisee">{{ cr.cr_type_activite_realisee }}</span>
</div>
<div class="date">
  <span *ngIf="cr.cr_activite_interne_date_fin">
    {{ cr.cr_activite_interne_date_fin | date: 'dd/MM/yyyy à HH:mm' }}
  </span>
</div>
<div class="status">
  <span *ngIf="cr.id; else displayStatus">
    {{ 'CR.ENVOYE' | translate }}
  </span>
  <ng-template #displayStatus>
    <span>
      {{ cr.etat }}
    </span>
  </ng-template>
</div>
